import { authStorage } from 'storages/authStorage';
import {
  createAuthUrl,
  generateCodeChallengeFromVerifier,
  generateCodeVerifier,
  getRedirectCompleteUrl,
} from 'app/services/AuthService/config';
import { AuthConfigInterface } from 'app/services/AuthService/AuthConfigInterface';

export const goToAuth = async (authConfig: AuthConfigInterface) => {
  const state = generateCodeVerifier();
  const verifier = generateCodeVerifier();
  const returnUrl = window.location.href;

  const authUrl = createAuthUrl({
    state,
    codeChallenge: await generateCodeChallengeFromVerifier(verifier),
    redirectUrl: getRedirectCompleteUrl(),
    authConfig,
  });

  await authStorage.setJwtAuthParams({ state, verifier, returnUrl });

  window.location.href = authUrl;

  return Promise.reject();
};
